require('./RAContribution.scss');

// @vendors
const React = require('react');
const PropTypes = require('prop-types');

// @utilities
const CurrencyHelper = require('utilities/currencyHelper');

// @constants
const { EURO_SYMBOL } = require('constants/index');

class RAContribution extends React.Component {
    shouldComponentUpdate(nextProps) {
        const { amount, color, title } = this.props;

        // Amount can change to be an object, in that case, use lodash comparator
        return (
            amount !== nextProps.amount ||
            color !== nextProps.color ||
            title !== nextProps.title
        );
    }

    buildContributionContent() {
        const { amount, color, title } = this.props;
        const amountText = CurrencyHelper.getFormattedString({
            amount,
            currency: EURO_SYMBOL,
        });
        return (
            <div className="ra-contribution-container">
                <div
                    className="ra-contribution__bar"
                    style={{ backgroundColor: color }}
                />
                <div className="ra-contribution__content">
                    <span className="ra-contribution__title">{title}</span>
                    <span className="ra-contribution__amount">
                        {amountText}
                    </span>
                </div>
            </div>
        );
    }

    render() {
        const { amount, title } = this.props;
        const content =
            amount > 0 && !!title ? this.buildContributionContent() : '';
        return <div className="ra-contribution">{content}</div>;
    }
}

RAContribution.propTypes = {
    // TODO: If amount is changed to an object, remember to update shouldComponentUpdate
    amount: PropTypes.number.isRequired,
    color: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
};

module.exports = RAContribution;
